import Script from "next/script";

import type { ExternalWidgetBokun as ExternalWidgetBokunType } from "../../types/ExternalWidget";

export type ExternalWidgetBokunContentProps = Pick<ExternalWidgetBokunType, "bookingChannelId">;

export function ExternalWidgetBokunContent({ bookingChannelId }: ExternalWidgetBokunContentProps) {
    const id = `external-widget-bokun-${bookingChannelId}`;
    const scriptURL = new URL("https://widgets.bokun.io/assets/javascripts/apps/build/BokunWidgetsLoader.js");
    scriptURL.searchParams.set("bookingChannelUUUID", bookingChannelId);

    return (
        <>
            <Script id={id} src={scriptURL.toString()} />
        </>
    );
}
